module.exports = __webpack_public_path__ + "static/media/evergreen-home.2e14c7cb.png";